<template>
    <div v-html="renderedMarkdown" class="markdown-content"></div>
</template>

<script>
import { marked } from 'marked';

export default {
    name: "MarkdownRenderer",
    props: {
        content: {
            type: String,
            default: ""
        }
    },
    computed: {
        renderedMarkdown() {
            const renderer = new marked.Renderer();
            const originalTable = renderer.table;
            const content = this.content ? this.content : ""
            
            renderer.table = function(header, body) {
                const html = originalTable.call(this, header, body);
                return html.replace('<table>', '<table class="table table-sm table-nowrap">');
            };
            
            const options = {
                renderer: renderer
            };
            
            return marked.parse(content, options);
        }
    }
}
</script>
<style scoped>
.markdown-content :deep(table) {
    font-size: 0.75rem;
    margin: 0.5rem 0;
}

.markdown-content :deep(table thead th) {
    padding: 0.375rem 0.5rem;
    font-size: 0.7rem;
    font-weight: 600;
}

.markdown-content :deep(table tbody td) {
    padding: 0.375rem 0.5rem;
    font-size: 0.75rem;
}

.markdown-content :deep(table tbody tr td) {
    border-bottom: 1px solid #ebf3fa;
    border-left: 1px solid #ebf3fa;
    border-right: 1px solid #ebf3fa;
}

.markdown-content :deep(table tbody tr:last-child) {
    border-bottom: 1px solid #ebf3fa;
}
</style>
